import React from 'react';
import { Hash, FileText } from 'lucide-react';

export default function EvidenceChain({ events = 0, evidenceRecords, evidenceId, hash, history = 14 }) {
  return (
    <div className="bg-slate-50 rounded-lg border border-slate-200 p-4 font-mono">
      <div className="text-[10px] uppercase tracking-wider text-apex-neutral mb-2">Evidence Chain</div>
      <div className="flex flex-col gap-1.5 text-[11px] text-apex-ink-2">
        <div className="flex justify-between gap-3"><span>Derived from {history} months of CloudTrail</span><span>{(events ?? 0).toLocaleString()} API calls</span></div>
        {evidenceRecords !== undefined && (
          <div className="flex justify-between"><span>Evidence records</span><span>{evidenceRecords}</span></div>
        )}
        {evidenceId && (
          <div className="flex items-center gap-1 truncate"><FileText className="w-3 h-3 shrink-0" /><span className="truncate">{evidenceId}</span></div>
        )}
        {hash && (
          <div className="flex items-center gap-1 truncate text-apex-lens"><Hash className="w-3 h-3 shrink-0" /><span className="truncate">{hash}</span></div>
        )}
      </div>
    </div>
  );
}
